<template>
  <div class="mb-6 overflow-auto">
    <table class="w-full table table-report">
      <thead class="p-3">
        <tr>
          <th
            v-for="(key, index) in columns"
            :key="index"
            :class="{ 'text-red active': sortKey == key }"
            class="cursor-pointer text-left px-4 py-2 capitalize"
          >
            <button type="button" @click="sortBy(key)">
              {{ columnLabels[key] || key }}
              <span
                class="arrow"
                :class="
                  (serverSide
                  ? sort === `${key}:asc`
                  : sortOrders[key] > 0)
                    ? 'asc'
                    : 'dsc'
                "
              >
              </span>
            </button>
          </th>
          <th class="text-left px-4 py-2 capitalize">
            Actions
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(entry, index) in filteredData"
          :key="entry.id || index"
          class="hover:bg-gray-100 transition"
        >
          <td v-for="(key, i) in columns" :key="i" class="border-b px-4 py-2">
            <span
              v-if="
                key !== 'active' && key !== 'hasTeam' && key !== 'lifeChurch'
              "
              :class="{ 'font-bold text-base': key == 'name' }"
              class="block"
            >
              {{ entry[key] }}
              <span v-if="key == 'name'" class="block font-normal">{{
                entry["email"]
              }}</span>
            </span>
            <span v-if="key == 'hasTeam'" class="block">
              <span
                :class="{ 'btn-outline-danger': !entry[key] }"
                class="btn btn-outline-primary w-24"
                ><span v-if="!entry[key]">No</span> Team</span
              >
            </span>
            <span v-if="key == 'lifeChurch'" class="block">
              <span v-if="entry[key]"
                >LifeChurch <br /><span class="italic">{{
                  entry["lifeChurchLocation"]
                }}</span></span
              >
            </span>
          </td>
          <td class="border-b px-4 py-2">
            <router-link
              class="btn btn-outline"
              :to="`/participants/${entry['id']}`"
              ><EditIcon class="h-4 w-4 mr-1" /> Edit</router-link
            >
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from "vue";

export default defineComponent({
  props: {
    serverSide: Boolean,
    sort: { type: String, default: "" },
    gridData: {
      type: Array,
      default: function() {
        return [];
      },
      required: false
    },
    query: {
      type: String,
      default: function() {
        return "";
      },
      required: false
    }
  },
  emits: ["sort"],
  setup(props, { emit }) {
    const localSortKey = ref("");
    const sortKey = computed(() =>
      props.serverSide ? props.sort.split(":")[0] : localSortKey.value
    );
    const columnLabels = {
      name: "Name",
      hasTeam: "Team",
      phone: "Phone",
      email: "Email",
      lifeChurch: "LifeChurch",
      eventCity: "City",
      eventYear: "Year"
    };
    let columns = [
      "name",
      "hasTeam",
      "phone",
      "email",
      "lifeChurch",
      "eventCity",
      "eventYear"
    ];
    let sortOrders = reactive({});
    columns.forEach(function(key) {
      sortOrders[key] = 1;
    });

    const filteredData = computed(() => {
      if (props.serverSide) return props.gridData;
      let searchQuery = props.query;
      let data = props.gridData;
      let theSortKey = sortKey.value;
      let theSearchQuery = searchQuery && searchQuery.toLowerCase();
      let order = sortOrders[theSortKey] || 1;
      if (searchQuery) {
        data = props.gridData.filter(function(row) {
          return Object.keys(row).some(function(key) {
            return (
              String(row[key])
                .toLowerCase()
                .indexOf(theSearchQuery) > -1
            );
          });
        });
      }
      if (theSortKey) {
        data = data.slice().sort(function(a, b) {
          a = a[theSortKey];
          b = b[theSortKey];
          return (a === b ? 0 : a > b ? 1 : -1) * order;
        });
      }
      return data;
    });

    const sortBy = key => {
      if (props.serverSide) {
        emit("sort", {
          key,
          direction: props.sort === `${key}:asc` ? "desc" : "asc"
        });
        return;
      }
      localSortKey.value = key;
      sortOrders[key] = sortOrders[key] * -1;
    };

    return {
      sortKey,
      sortOrders,
      columns,
      columnLabels,
      filteredData,
      sortBy
    };
  }
});
</script>
<style scoped>
.table-report tr:hover td {
  @apply bg-gray-100;
}

th.active .arrow {
  opacity: 1;
}

.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #000;
}

.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #000;
}
</style>
